import { BaseService } from './BaseService';
import { FetchResult } from 'apollo-link';
import { ApolloQueryResult } from 'apollo-client';
import listCustomerOrganizations from '@/graphql/queries/FetchCustomerOrganizations.gql';
import updateCustomerOrg from '@/graphql/mutations/customerOrganization/Update.gql';
import hideCustomerOrganization from '@/graphql/mutations/CustomerOrganizationHide.gql';
import {
  CustomerOrganizationInput,
  CustomerOrganizationHideInput,
  PaginationInput,
  fetchCustomerOrganizations,
  updateCustomerOrganization,
  hideCustomerOrganization_hideCustomerOrganization,
  CustomerOrganizationFilterEnum
} from '@/types/graphql/schemaTypes';

class CustomerOrganizationService extends BaseService {
  public listCustomerOrganizations(
    customerOrganizationArgs?: any,
    pagination?: PaginationInput | null,
    filter?: CustomerOrganizationFilterEnum | null
  ): Promise<ApolloQueryResult<fetchCustomerOrganizations>> {
    return this.client.query({
      query: listCustomerOrganizations,
      variables: {
        filter,
        pagination,
        customerOrganizationArgs: customerOrganizationArgs || {}
      }
    });
  }

  public updateCustomerOrganization(customerOrganizationArgs: CustomerOrganizationInput):
    Promise<FetchResult<updateCustomerOrganization>> {
    return this.client.mutate({
      mutation: updateCustomerOrg,
      variables: {
        customerOrganizationArgs
      }
    }).then((result) => {
      return result;
    });
  }

  public hideCustomerOrganization(hideCustomerOrganizationArgs: CustomerOrganizationHideInput):
    Promise<FetchResult<hideCustomerOrganization_hideCustomerOrganization>> {
    return this.client.mutate({
      mutation: hideCustomerOrganization,
      variables: {
        customerOrganizationArgs: hideCustomerOrganizationArgs
      }
    }).then((result) => {
      return result;
    });
  }
}

export const customerOrganizationService = new CustomerOrganizationService();
